// extracted by mini-css-extract-plugin
module.exports = {"header":"Releases_header__1EOrT","releases":"Releases_releases__33SDx","img":"Releases_img__3dHbq"};